import { render, staticRenderFns } from "./UploadTicketsDragAndDrop.vue?vue&type=template&id=2a6eaebc&scoped=true&"
import script from "./UploadTicketsDragAndDrop.vue?vue&type=script&lang=ts&"
export * from "./UploadTicketsDragAndDrop.vue?vue&type=script&lang=ts&"
import style0 from "./UploadTicketsDragAndDrop.vue?vue&type=style&index=0&id=2a6eaebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6eaebc",
  null
  
)

export default component.exports